import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import 'leaflet/dist/leaflet.css';

// Components
import './components/1-atoms';
import './components/2-molecules';
import './components/3-organisms';

// Filters
import ThousandsSeparator from './helpers/filters/thousands-separator';
import DecimalSeparator from './helpers/filters/decimal-separator';
import ConvertString from './helpers/filters/string-covert';

Vue.filter('thousandsSeparator', ThousandsSeparator);
Vue.filter('decimalSeparator', DecimalSeparator);
Vue.filter('convertString', ConvertString);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-149505412-2',
});

store.dispatch('rawData/fetchData');

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
